import { render } from "./BonusYearDetail.vue?vue&type=template&id=3d494ad4&scoped=true"
import script from "./BonusYearDetail.vue?vue&type=script&lang=js"
export * from "./BonusYearDetail.vue?vue&type=script&lang=js"

import "./BonusYearDetail.vue?vue&type=style&index=0&id=3d494ad4&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-3d494ad4"

export default script